import DataLayerHelper from "@/helpers/global/dataLayer.helper";

export class BuilderStore {
  save_cookie_name: string = '';
  saved_heaters: any = null;

  canStore() {
    const test = 'test';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

  saveHeater(label, build_num, product, builder_page, selected_options, product_upgrades, index) {
    let isChecked = false;
    let heaterLabel = label;

    if (typeof index == 'undefined' || index == null) {
      index = -1;
    } else {
      //we are editing the heater, so the label will always be what it was originally saved with.
      heaterLabel = this.saved_heaters[index].label;
      isChecked = this.saved_heaters[index].checked;
    }

    if (this.canStore) {
      try {
        const cfg = {
          label: heaterLabel,
          build_num: build_num,
          product: product,
          builder_page: builder_page,
          selected_options: selected_options,
          product_upgrades: product_upgrades,
          checked: false,
        };
        if (index == -1) {
          cfg.checked = true;
          index = 0;
          this.saved_heaters.unshift(cfg);
        } else {
          cfg.checked = isChecked;
          this.saved_heaters[index] = cfg;
        }
        this.saveHeaters();
      } catch (e) {
        console.log('uh-oh', e);
      }
      return index;
    }
  }

  saveHeaters() {
    localStorage.setItem(this.save_cookie_name, JSON.stringify(this.saved_heaters));
  }

  loadSavedHeaters() {
    this.saved_heaters = [];
    if (this.canStore) {
      this.saved_heaters = JSON.parse(localStorage.getItem(this.save_cookie_name));
      if (this.saved_heaters == null) {
        this.saved_heaters = [];
      }
    }
    return this.saved_heaters;
  }

  init() {
    this.save_cookie_name = 'FarnamSavedBuilder_1.0';
    this.saved_heaters = null;
    this.loadSavedHeaters();
  }
}

export class BuilderStoreUI {
  builder: any = undefined;
  store: any = undefined;
  currentlyEditing: any = null;

  constructor(builder: any) {
    this.builder = builder;
  }

  sendInquiry(event) {
    const product_codes = [];
    let product_upgrades = [];
    for (let i = 0; i < this.store.saved_heaters.length; i++) {
      if (this.store.saved_heaters[i].checked) {
        product_codes.push(this.store.saved_heaters[i].build_num);
        if (typeof this.store.saved_heaters[i].product_upgrades != 'undefined' && this.store.saved_heaters[i].product_upgrades.length > 0) {
          product_upgrades = product_upgrades.concat(this.store.saved_heaters[i].product_upgrades);
        }
      }
    }
    product_upgrades = [...new Set(product_upgrades)];
    $('#contact-form-heating-needs').children().hide();
    $('.what-are-you-heating, #more-info-section').hide();
    $('#fieldset-contact-information').show();
    $('#fieldset-contact-information').attr('style', 'margin-top:0px');
    this.builder.sendInquiry(product_codes, product_upgrades);
  }

  updateNumBuilds(cfg) {
    $('.saved-builds .num_builds').text(cfg.length);
  }

  maybeSaveHeater(e) {
    if (this.currentlyEditing == null) {
      $('#save-build-modal').modal('show');
      $('#save-build-label').val('');
      $('#contact-form-for-byo-modal-label .product-name').text(this.getProduct());
      $('#contact-form-for-byo-modal-label .built-number').text(this.getProductCode());
    } else {
      this.saveHeater(e);
    }
  }

  logEvent(action, label) {
    DataLayerHelper.send('product_builder_event', "Product builder", action,label,1);
  }

  clearAllChecks() {
    for (let i = 0; i < this.store.saved_heaters.length; i++) {
      this.store.saved_heaters[i].checked = false;
      this.store.saveHeaters();
    }
  }

  saveHeater(e) {
    e.stopImmediatePropagation();
    const product = this.getProduct();
    const product_code = this.getProductCode();
    const label = $('#save-build-label').val();
    const page_url = window.location.pathname;
    const selected_options = this.builder.selected_options;
    const product_upgrades = [];
    $('.product-updgrade-options input:checked').each(function () {
      product_upgrades.push($('label[for="' + $(this).attr('id') + '"]').html());
    });

    const index = this.store.saveHeater(label, product_code, product, page_url, selected_options, product_upgrades, this.currentlyEditing);
    this.logEvent('saved-build', product);
    $('#save-build-modal').modal('hide');
    $('#save-build-label').val('');
    $('#savedBuilds').collapse('show');
    this.updateUI(this.store.saved_heaters);
    if (this.currentlyEditing != null) {
      $('#savedBuilds table tbody tr.row-' + this.currentlyEditing).pulsate({
        color: '#6baa8b', // set the color of the pulse
        reach: 10, // how far the pulse goes in px
        speed: 250, // how long one pulse takes in ms
        pause: 0, // how long the pause between pulses is in ms
        glow: true, // if the glow should be shown too
        repeat: 2, // will repeat forever if true, if given a number will repeat for that many times
        onHover: false, // if true only pulsate if user hovers over the element
      });
    } else {
      $('#savedBuilds table tbody tr.row-' + 0).pulsate({
        color: '#6baa8b', // set the color of the pulse
        reach: 10, // how far the pulse goes in px
        speed: 250, // how long one pulse takes in ms
        pause: 0, // how long the pause between pulses is in ms
        glow: true, // if the glow should be shown too
        repeat: 3, // will repeat forever if true, if given a number will repeat for that many times
        onHover: false, // if true only pulsate if user hovers over the element
      });
    }
    this.currentlyEditing = null;
    this.clearBuilderSelections();
    const scrollToPosition = $('#saved-builds-toggle').offset().top - $('.navbar-fixed-top').height() - 45;
    $('html, body').animate({ scrollTop: scrollToPosition }, 1000);
  }

  getProductCode() {
    let ignoreNextDash = false;
    let product_code = '';
    $('#build-your-own .product-code > span').each(function () {
      //in some instances the "phase" vallue does not have options, and farnam wants that segment removed fromt eh product code.
      //so if the span is empty then we want to remove the next dash as well so that we don't end up with two dashes --
      if (ignoreNextDash && $(this).text() == '-') {
        //ignore this dash
        ignoreNextDash = false;
      } else {
        if ($(this).text() != '') {
          product_code += $(this).text();
        } else {
          ignoreNextDash = true;
        }
      }
    });
    //if the code has a trailing dash then remove it.
    if (product_code.slice(-1) == '-') {
      product_code = product_code.substring(0, product_code.length - 1);
    }
    return product_code;
  }

  getProduct() {
    if ($("#builder-type-1 li[data-option-id='" + $('.builder-type-value').val() + "']").text() == '') {
      if (typeof product_name == 'undefined') {
        return 'No Selected Heater';
      }
      return product_name;
    }
    return $("#builder-type-1 li[data-option-id='" + $('.builder-type-value').val() + "']").text();
  }

  updateUI(cfg) {
    const g = this;
    this.createTable(cfg);
    $('.saved-builds .num_builds').text(this.store.saved_heaters.length);
    $('#savedBuilds .edit-button').click(function (e) {
      g.editBuild(e);
    });
    $('#savedBuilds .delete-button').click(function (e) {
      g.deleteBuild(e);
    });
    $('#savedBuilds .copy-button').click(function (e) {
      g.copyBuild(e);
    });
    $('#savedBuilds .build.checkbox input').change(function (e) {
      const index = $(e.currentTarget).data('index');
      g.store.saved_heaters[index].checked = $(e.currentTarget).prop('checked');
      g.store.saveHeaters();
    });
  }

  createTable(cfg) {
    let html = '';
    if (cfg == null) {
      $('#savedBuilds table tbody').html('');
      return;
    }
    for (let i = 0; i < cfg.length; i++) {
      const checked = cfg[i].checked ? 'checked' : '';
      let img = this.getImageUrl(cfg[i].build_num);
      if (img != '') {
        img = '<img src="' + img + '" style="width:auto;height:35px;">';
      }

      html =
        html +
        `
        <tr class="row-` +
        i +
        `">
          <td>
            <div class="build checkbox">
              <input type="checkbox" data-index= "` +
        i +
        '" id="build_' +
        i +
        '" name="build_' +
        i +
        '" ' +
        checked +
        `>
              <label for="build_` +
        i +
        `"></label>
            </div>
          </td>
          <td class="hide-mobile">` +
        img +
        `</td>
          <td class="primary">` +
        cfg[i].label +
        '<span class="hide-desktop">' +
        (cfg[i].label != '' ? '<br>' + cfg[i].product : cfg[i].product) +
        '<br>' +
        cfg[i].build_num +
        `</span></td>
          <td class="hide-mobile">` +
        cfg[i].product +
        `</td>
          <td class="hide-mobile">` +
        cfg[i].build_num +
        `</td>
          <td>
            <div data-toggle="tooltip" title="Edit" class="edit-button btn" data-link="` +
        cfg[i].link +
        '" data-index="' +
        i +
        `"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></div>
            <div data-toggle="tooltip" title="Copy" class="copy-button btn" data-index="` +
        i +
        `"><span class="glyphicon glyphicon-duplicate" aria-hidden="true"></span></div>
            <div data-toggle="tooltip" title="Delete" class="delete-button btn" data-index="` +
        i +
        `"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></div>
          </td>
        </tr>
        <tr class="border-bottom"><td></td><td></td><td></td></tr>
        `;
    }
    $('#savedBuilds table tbody').html(html);
  }

  getImageUrl(build_num) {
    const prefix = build_num.split('-');
    let imageUrl = '';
    if (prefix[0] == '?') {
      return '';
    } else if (prefix[0].substring(0, 2) == 'CB') {
      imageUrl = 'media/product_photos/Crossflow_Blower_Heater.png';
    } else if (prefix[0].substring(0, 2) == 'DH') {
      imageUrl = 'media/product_photos/ductheater.png';
    } else if (prefix[0].substring(0, 2) == 'AF') {
      imageUrl = 'media/product_photos/Axial_Fan_Heaters.png';
    } else if (prefix[0].substring(0, 4) == '7550') {
      imageUrl = 'media/product_photos/controlpanel_copy.png';
    } else if (prefix[0].substring(0, 4) == 'CC') {
      imageUrl = 'media/product_photos/controlcube-small.png';
    } else if (prefix[0].substring(0, 4) == 'SHF') {
      imageUrl = 'media/product_photos/_thumbs/' + build_num.replace('-', '0') + '.png';
    } else if (prefix[0].substring(0, 2) == 'HT' && prefix[1] == 'M') {
      if (prefix[2] == '050') {
        imageUrl = 'media/product_photos/ht050.png';
      } else {
        imageUrl = 'media/product_photos/ht075.png';
      }
    } else {
      imageUrl = 'media/product_photos/' + prefix[0].toLowerCase() + '.png';
    }

    return `${LEGACY_FILES_CDN_URL}farnam-legacy/${imageUrl}`;
  }

  editBuild(event) {
    const index = event.currentTarget.getAttribute('data-index');
    this.currentlyEditing = index;
    this.logEvent('edited-build', this.store.saved_heaters[index].product);
    const cfg = this.store.saved_heaters[index];
    if (window.location.pathname != cfg.builder_page) {
      window.location.href = cfg.builder_page + '?builder-index=' + index + '&edit=true#product_code_designation';
      return;
    }
    this.loadIntoBuilder(cfg, cfg.product_upgrades);
    const scrollToPosition = $('#product_code_designation').offset().top - $('.navbar-fixed-top').height() - 45;
    $('html, body').animate({ scrollTop: scrollToPosition }, 1000);
  }

  loadIntoBuilder(cfg, upgrades) {
    this.clearBuilderSelections();
    const g = this;
    Object.keys(cfg.selected_options).forEach(function (typeID) {
      const option_code = $('#builder-type-' + typeID + " li[data-option-id='" + cfg.selected_options[typeID] + "']").data('option-code');
      g.builder.selected_options[typeID] = cfg.selected_options[typeID];
      $('#builder-type-' + typeID + '-value').val(cfg.selected_options[typeID]);
      $('#builder-option-' + cfg.selected_options[typeID]).addClass('selected');
      $('.mobile-builder-option-' + cfg.selected_options[typeID]).addClass('selected');

      $('#type-' + typeID + '-code').html(option_code);
      g.builder.num_selected++;
    });
    if (typeof upgrades != 'undefined') {
      for (let i = 0; i < upgrades.length; i++) {
        $(".product-updgrade-options .checkbox input[data-upgrade='Upgrade - " + upgrades[i] + "']").prop('checked', true);
      }
    }

    const self = this;
    const callbackF = function () {
      self.builder.getControlPanelPart(true);
    };

    this.builder.getExclusions(callbackF);
  }

  copyBuild(event) {
    const index = event.currentTarget.getAttribute('data-index');
    this.logEvent('copied-build', this.store.saved_heaters[index].product);
    this.currentlyEditing = null;
    const cfg = this.store.saved_heaters[index];
    if (window.location.pathname != cfg.builder_page) {
      window.location.href = cfg.builder_page + '?builder-index=' + index + '&edit=false#product_code_designation';
      return;
    }
    this.loadIntoBuilder(cfg, cfg.product_upgrades);
    const scrollToPosition = $('#product_code_designation').offset().top - $('.navbar-fixed-top').height() - 45;
    $('html, body').animate({ scrollTop: scrollToPosition }, 1000);
  }

  deleteBuild(event) {
    event.stopImmediatePropagation();
    const index = event.currentTarget.getAttribute('data-index');
    this.logEvent('deleted-build', this.store.saved_heaters[index].product);
    this.store.saved_heaters.splice(index, 1);
    this.store.saveHeaters();
    this.updateUI(this.store.saved_heaters);
    if (this.store.saved_heaters.length == 0) {
      $('#savedBuilds').collapse('hide');
    }
  }

  clearBuilderSelections() {
    this.builder.num_selected = 0;
    this.builder.selected_options = {};
    $('.builder-type-value').val('');
    $('.builder-option').removeClass('selected');
    $('.builder-option').removeClass('excluded');
    $('.product-code .code').html('?');
    $('.product-code .code').each(function () {
      if (typeof $(this).attr('data-preset-value') != 'undefined' && $(this).attr('data-preset-value') != '') {
        $(this).html($(this).attr('data-preset-value'));
      }
    });
    $('.product-updgrade-options .checkbox input').prop('checked', false);
  }

  getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  init() {
    this.store = new BuilderStore();
    this.store.init();

    const g = this;
    this.updateUI(this.store.saved_heaters);
    $('#save-build-submit').click(function (e) {
      g.saveHeater(e);
    });
    $('#builder-save-build').click(function (e) {
      g.maybeSaveHeater(e);
    });
    $('#builder-save-build_bottom').click(function (e) {
      g.maybeSaveHeater(e);
    });
    //allow the enter key to submit the save build when typing in a label.
    $('#save-build-label').bind('enterKey', function (e) {
      g.maybeSaveHeater(e);
    });
    $('#save-build-label').on('keypress', function (e) {
      if (e.keyCode == 13) {
        e.stopImmediatePropagation();
        g.saveHeater(e);
        return false;
      }
    });
    $('#builder-send-inquiry2').click(function (e) {
      g.sendInquiry(e);
    });
    //when clearing form reset the currently editing index.
    $('#build-your-own').on('click', '#builder-clear', function () {
      g.currentlyEditing = null;
    });
    $('#contact-form-submit').on('click', function () {
      g.clearAllChecks();
    });
    //when linking to this build, this will load the heater.
    const i = this.getUrlParameter('builder-index');
    if (i != '') {
      if (this.getUrlParameter('edit') == 'true') {
        this.currentlyEditing = i;
      }
      const cfg = this.store.saved_heaters[i];
      setTimeout(function () {
        g.loadIntoBuilder(cfg, cfg.product_upgrades);
      }, 500);
    }
    $('.mobile-builder .tabs-left ul.nav-tabs li:first-child').addClass('active');
    $('.mobile-builder .tab-content .tab-pane:first-child').addClass('active');
    $('.scroll-handle').each(function (ix, el) {
      $(el).attr('title', 'scroll handle');
    });
  }
}

export class FarnamProductBuilder {
  catID: string | number | string[] = '';
  pre_selected_ids_string: string = '';
  pre_selected_ids: string[] = [];
  types: any = undefined;
  num_types: number = 0;
  num_selected: number = 0;
  selected_options: any = undefined;
  store: any = undefined;

  sendInquiry(product_code, product_upgrades) {
    let product_upgrades_text = '';

    if (product_upgrades.length) {
      product_upgrades_text =
        '\n\n\n\n--------------------------------------\nI am also interested in learning more about the following upgrades: ' +
        product_upgrades.join(', ');
    }

    let product_code_str = '';
    let product_code_fields = '';
    if (typeof product_code == 'object') {
      for (let i = 0; i < product_code.length; i++) {
        product_code_str = product_code_str + product_code[i] + '\n';
        product_code_fields = product_code_fields + "<input type='hidden' name='LEADCF1' value='" + product_code[i] + "'>";
      }
    } else {
      product_code_str = product_code;
      product_code_fields = "<input type='hidden' name='LEADCF1' value='" + product_code + "'>";
    }
    const build_code_field =
      '' +
      '<p class="text-center">Thank you for using our product builder! Please fill out the following fields and we will get back to you shortly.</p>' +
      '<fieldset id="build_code_field">' +
      '	<legend>Product Inquiry</legend>' +
      '	<div class="col-xs-12 text-center">' +
      '		<div class="form-group flip-label">' +
      '			<textarea rows="3" class="form-control" id="inquiry-product-code" readonly name="PC">' +
      product_code_str +
      '</textarea>' +
      '			' +
      product_code_fields +
      '			<label for="contact-first-name" class="focused">Build #:</label>' +
      '			<div class="help-block with-errors"></div>' +
      '		</div>' +
      '	</div>' +
      '	<div class="col-xs-12 col-sm-7">' +
      '		<div class="form-group flip-label">' +
      '			<textarea class="form-control" name="LEADCF10" rows="10" id="contact-more-info">' +
      product_upgrades_text +
      '</textarea>' +
      '			<label for="contact-more-info">More Info</label>' +
      '		</div>						' +
      '	</div>' +
      '	<div class="col-xs-12 col-sm-5">' +
      '		<h3>Please Include:</h3>' +
      '		<ul>' +
      '			<li>Questions &amp; Comments</li>' +
      '			<li>Specifications &amp; Limitations</li>' +
      '			<li>Unique Conditions or Challenges</li>' +
      '		</ul>' +
      '	</div>' +
      '</fieldset>';

    $('#product_code_container').html(build_code_field);
  }

  getExclusions(callbackF) {
    const me = this;

    $.ajaxSetup({
      headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
    });

    $.ajax({
      type: 'POST',
      cache: false,
      headers: { 'X-CSRFToken': CSRF_TOKEN },
      url: `${WEBSITE_API_URL}/byo/option_exclusions/`,
      data:
        'selected_options=' + JSON.stringify(me.selected_options) + '&catID=' + me.catID + '&pre_selected_ids=' + JSON.stringify(me.pre_selected_ids),
      success: function (data, status) {
        const exclusions = data;
        $('.builder-option').removeClass('excluded');

        if (exclusions.count > 0) {
          $.each(exclusions.exclusions, function (key, exclusion) {
            $('#builder-option-' + exclusion).addClass('excluded');
            $('.mobile-builder-option-' + exclusion).addClass('excluded');
          });
        }

        $('.desktop-builder :not(.product-updgrade-options) .builder-type').each(function (i, d) {
          const c = $(this).find('ul.option-list li:not(.excluded)');
          if (c.length == 0) {
            var typeID = $(this).data('type-id');
            if ($('#type-' + typeID + '-code').html() == '?') {
              $('#type-' + typeID + '-code').html('');
            }
          } else {
            var typeID = $(this).data('type-id');
            const s = $(this).find('ul.option-list li.selected');
            if (s.length == 0) {
              $('#type-' + typeID + '-code').html('?');
            }
          }
        });

        $('.desktop-builder :not(.product-updgrade-options) .builder-type').each(function (i, d) {
          const c = $(this).find('ul.option-list li:not(.excluded)');
          if (c.length == 0) {
            var typeID = $(this).data('type-id');
            if ($('#type-' + typeID + '-code').html() == '?') {
              $('#type-' + typeID + '-code').html('');
            }
          } else {
            var typeID = $(this).data('type-id');
            const s = $(this).find('ul.option-list li.selected');
            if (s.length == 0) {
              $('#type-' + typeID + '-code').html('?');
            }
          }
        });

        $('.builder-option').removeClass('processing');
        callbackF();
      },
    });
  }

  controlPanelHelper() {
    const ampOptionsArr = [
      {
        mcb: 15,
        fla: 12,
      },
      {
        mcb: 20,
        fla: 16,
      },
      {
        mcb: 30,
        fla: 24,
      },
      {
        mcb: 40,
        fla: 32,
      },
      {
        mcb: 50,
        fla: 40,
      },
      {
        mcb: 60,
        fla: 48,
      },
      {
        mcb: 80,
        fla: 64,
      },
      {
        mcb: 100,
        fla: 80,
      },
      {
        mcb: 125,
        fla: 96,
      },
    ];

    const selectMCBFromFLA = (flaValue) => {
      let mcbValue = 15;
      ampOptionsArr.forEach((item, index) => {
        if (index > 0) {
          const flaFrom = ampOptionsArr[index - 1].fla;
          const flaTo = item.fla;

          if (flaValue > flaFrom && flaValue <= flaTo) {
            mcbValue = item.mcb;
          } else if (flaValue > flaTo) {
            mcbValue = ampOptionsArr[ampOptionsArr.length - 1].mcb;
          }
        }
      });

      return mcbValue;
    };

    const calculateProductAmpFLA = (watts, volts, phase) => {
      return Math.round(watts / volts / Math.sqrt(phase));
    };

    function generateProductPartNumber(watts, volts, phase) {
      const productPartNumberObj = {
        result: null,
        error: null,
      };

      if (watts && volts && phase) {
        if (+watts < 0) {
          productPartNumberObj.error = 'Watts must be greater then 0';
        } else if ((+volts === 120 || +volts === 277) && +phase === 3) {
          productPartNumberObj.error = 'For selected voltage you can use only 1 phase';
        } else if (+volts === 400 && +phase === 1) {
          productPartNumberObj.error = 'For selected voltage you can use only 3 phase';
        } else {
          const productAmpFLA = calculateProductAmpFLA(+watts, +volts, +phase);
          const productAmpMCB = selectMCBFromFLA(productAmpFLA);
          productPartNumberObj.result = `CP-${+volts}-${+phase}PH-${productAmpMCB}`;
        }
      } else {
        productPartNumberObj.error = 'Watts, volts and phase are required fields.';
      }

      return productPartNumberObj;
    }

    return generateProductPartNumber;
  }

  setControlPanelPart(builder_type = 'desktop-builder', is_update = false) {
    const wattage = $(`.${builder_type} div#builder-type-2 li.selected`).data('option-code');
    const voltage = $(`.${builder_type} div#builder-type-3 li.selected`).data('option-code');
    let phase = $(`.${builder_type} div#builder-type-15 li.selected`).data('option-code');
    const excluded_phases_length = $('div#builder-type-15 li.excluded').length;

    if (phase === undefined && excluded_phases_length === 4) {
      phase = 1;
    }

    const controller = $(`.${builder_type} div#builder-type-30 li.builder-option`).first();
    const result = this.controlPanelHelper()(wattage, voltage, phase);
    let option_code = 'CP';
    let option_text = 'Call for Control Options';
    if (result.error == null) {
      option_code = option_text = result.result;
    }
    controller.css({
      overflow: 'visible',
      height: 'auto',
      display: 'flex',
      'flex-wrap': 'wrap',
      gap: '2px',
      'justify-content': 'space-between',
    });

    const builderControllerOptionLink = localStorage.getItem('builderControllerOptionLinkLSKey');
    let controllerOptionHTML = '';
    if (builderControllerOptionLink !== null && builderControllerOptionLink !== 'null') {
      controllerOptionHTML = `<a href="${builderControllerOptionLink}" target="_blank">${option_text}</a>`;
    } else {
      controllerOptionHTML = `<span>${option_text}</span>`;
    }

    controller.html(controllerOptionHTML);

    $.each(controller, function (index, item) {
      $(item).attr('data-option-code', option_code);
      const option = $(item).closest('li').first();

      if (option.hasClass('selected')) {
        setTimeout(() => {
          option.trigger('click');
          if (is_update) {
            setTimeout(() => {
              option.trigger('click');
            }, 500);
          }
        }, 500);
      }
      if (is_update === false) {
        $(`.${builder_type} #builder-type-30-value`).val(null);
      }
    });
  }

  getControlPanelPart(is_update = false) {
    this.setControlPanelPart('desktop-builder', is_update);
    this.setControlPanelPart('mobile-builder', is_update);
  }

  selectThermocoupleFitting() {
    this.selectThermocoupleFittingByType('desktop-builder');
    this.selectThermocoupleFittingByType('mobile-builder');
  }

  selectThermocoupleFittingByType(builder_type = 'desktop-builder') {
    const items = $(`.${builder_type} div#builder-type-14 li`);

    const controller = $(`.${builder_type} div#builder-type-30 li.builder-option`).first();
    const controller_selected = $(controller).attr('data-option-code') !== 'CP' && controller.hasClass('selected') === true;

    items.each(function (index) {
      if ($(this).text() === '2 t/c fittings with 2 t/c' && $(this).hasClass('excluded') === false) {
        if (controller_selected) {
          if ($(this).hasClass('selected') === false) {
            $(this).trigger('click');
          }
        } else {
          if ($(this).hasClass('selected') === true) {
            $(this).trigger('click');
          }
        }
      }
    });
  }

  init() {
    const me = this;
    this.catID = $('#builder_catID').val();
    this.pre_selected_ids_string = String($('#pre_selected_ids').val());

    this.pre_selected_ids = this.pre_selected_ids_string.split(',');
    this.types = $('.desktop-builder :not(.product-updgrade-options) .builder-type');
    this.num_types = this.types.length;
    this.num_selected = 0;
    this.selected_options = {};

    this.store = new BuilderStoreUI(me);
    this.store.init();

    $.each(this.types, function () {
      const typeID = $(this).attr('data-type-id');
      $('#build-your-own .product-code').append("<span class='code' id='type-" + typeID + "-code'>?</span><span class='code-divider'>-</span>");
      if (['2', '3'].includes(typeID) === true) {
        setTimeout(() => {
          $('#builder-type-' + typeID + ' ul.option-list').removeAttr('style');
        }, 1000);
      }
    });

    $.each(['desktop-builder', 'mobile-builder'], function (index, value) {
      const controller = $(`.${value} div#builder-type-30 li.builder-option`).first();
      controller.css({
        overflow: 'visible',
        height: 'auto',
        display: 'flex',
        'flex-wrap': 'wrap',
        gap: '2px',
        'justify-content': 'space-between',
      });

      const builderControllerOptionLink = localStorage.getItem('builderControllerOptionLinkLSKey');
      let controllerOptionHTML = '';
      if (builderControllerOptionLink !== null && builderControllerOptionLink !== 'null') {
        controllerOptionHTML = ` <a href="${builderControllerOptionLink}" target="_blank">Call for Control Options</a>`;
      } else {
        controllerOptionHTML = '<span>Call for Control Options</span>';
      }

      controller.html(controllerOptionHTML);
    });

    $('#build-your-own .product-code .code-divider:last-child').remove();

    $('#build-your-own').on('click', '#builder-clear', function () {
      me.num_selected = 0;
      me.selected_options = {};
      $('.builder-type-value').val('');
      $('.builder-option').removeClass('selected');
      $('.builder-option').removeClass('excluded');
      $('.product-code .code').html('?');
      $('.product-code .code').each(function () {
        if (typeof $(this).attr('data-preset-value') != 'undefined' && $(this).attr('data-preset-value') != '') {
          $(this).html($(this).attr('data-preset-value'));
        }
      });
    });

    $('#build-your-own').on('click', '#builder-send-inquiry', function () {
      $('#contact-form-heating-needs').children().hide();
      $('.what-are-you-heating, #more-info-section').hide();
      $('#fieldset-contact-information').show();
      $('#fieldset-contact-information').attr('style', 'margin-top:0px');

      let product_code = '';
      $('#build-your-own .product-code span').each(function () {
        product_code += $(this).text();
      });

      const product_upgrades = [];
      $('.product-updgrade-options input:checked').each(function () {
        product_upgrades.push($('label[for="' + $(this).attr('id') + '"]').html());
      });
      me.sendInquiry(product_code, product_upgrades);
    });

    $('#build-your-own').on('click', '.builder-option:not(.processing)', function (e) {
      if (e.target.tagName === 'A') {
        return;
      }
      $('.builder-option').addClass('processing');

      //grabs data fromt he option that was clicked.
      const option_code = $(this).attr('data-option-code');
      const optID = parseInt($(this).attr('data-option-id'));
      const typeID = parseInt($(this).attr('data-type-id'));
      // if upgrade option selected send data to Google Analytics and return
      if (option_code == 'upgrade') {
        const upgrade = $(this).attr('data-upgrade');
        DataLayerHelper.send('product_builder_option_clicked', "Product builder",  'Option click',upgrade,1);
        $('.builder-option').removeClass('processing');
        return;
      }

      //do some Google Analytics event tracking...
      DataLayerHelper.send('product_builder_option_clicked', "Product builder",  'Option click',`${typeID} - ${option_code}`,1);

      //get the currently selected option for this type
      const type_selected_option = $('#builder-type-' + typeID + '-value').val();

      //handles highlights, setting the option code in the product code,
      //if nothing selected yet...
      if (type_selected_option == '') {
        me.selected_options[typeID] = optID;
        $('#builder-type-' + typeID + '-value').val(optID);
        $(this).addClass('selected');
        $('#type-' + typeID + '-code').html(option_code);
        me.num_selected++;
      }
      //else, if something else was already selected...
      else if (type_selected_option != optID) {
        me.selected_options[typeID] = optID;
        $('#builder-type-' + typeID + '-value').val(optID);
        $('#builder-type-' + typeID + ' .builder-option').removeClass('selected');
        $(this).addClass('selected');
        $('#type-' + typeID + '-code').html(option_code);
      }
      //else if this option was already selected...
      else {
        delete me.selected_options[typeID];
        $('#builder-type-' + typeID + '-value').val('');
        $(this).removeClass('selected');
        $('#type-' + typeID + '-code').html('?');
        me.num_selected--;
      }

      //$('#type-'+typeID+'-code').effect('highlight');
      $('#type-' + typeID + '-code').pulsate({
        color: 'rgba(100,100,255,0.3)', // set the color of the pulse
        reach: 4, // how far the pulse goes in px
        speed: 300, // how long one pulse takes in ms
        pause: 0, // how long the pause between pulses is in ms
        glow: true, // if the glow should be shown too
        repeat: 1, // will repeat forever if true, if given a number will repeat for that many times
        onHover: false, // if true only pulsate if user hovers over the element
      });

      if (me.num_selected == me.num_types) {
        $('#builder-send-inquiry').pulsate({
          color: $(this).css('background-color'), // set the color of the pulse
          reach: 10, // how far the pulse goes in px
          speed: 500, // how long one pulse takes in ms
          pause: 0, // how long the pause between pulses is in ms
          glow: true, // if the glow should be shown too
          repeat: 3, // will repeat forever if true, if given a number will repeat for that many times
          onHover: false, // if true only pulsate if user hovers over the element
        });
      }

      //get option exclusions

      // test function
      const callbackF = function () {
        if ([1, 2, 3, 15].includes(typeID) === true) {
          me.getControlPanelPart();
        }
        me.selectThermocoupleFittingByType();
      };

      me.getExclusions(callbackF);
    });
  }
}
